var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { perRestaurant } from "../di";
import { t, translate } from "../I18n";
import { LocalizationProvider } from "../locale";
import { BottomSheetCrossSellingCreator, CrossSellingItemInstancePriceService, OrderLine, Price, PurchaseOrderPayload, } from "../ordering";
import { PCrossSellingCreatorFactory } from "./PCrossSellingCreatorFactory";
import { PPrice } from "./PPrice";
const MAX_ELEMENTS_TO_SHOW = 3;
let PCrossSellingBeforeCartOpenningBottomSheet = class PCrossSellingBeforeCartOpenningBottomSheet {
    constructor(pCrossSellingCreatorFactory, domainCrossSellingCreator, crossSellingItemInstancePriceService, localizationProvider, purchaseOrderPayload) {
        this.domainCrossSellingCreator = domainCrossSellingCreator;
        this.crossSellingItemInstancePriceService = crossSellingItemInstancePriceService;
        this.localizationProvider = localizationProvider;
        this.purchaseOrderPayload = purchaseOrderPayload;
        this.crossSellingCreator = pCrossSellingCreatorFactory.create(domainCrossSellingCreator);
    }
    get crossSellingItems() {
        return this.crossSellingCreator.items.raw.slice(0, MAX_ELEMENTS_TO_SHOW);
    }
    get price() {
        return Price.total(this.domainCrossSellingCreator.items.map((crossSellingItemInstance) => this.crossSellingItemInstancePriceService.totalPrice(crossSellingItemInstance)));
    }
    get pPrice() {
        return new PPrice(this.localizationProvider, this.price.spectrum);
    }
    get buttonText() {
        if (this.price.compare(Price.free()) > 0) {
            return {
                label: translate(t.client.cross_selling_bottomsheet.button.add),
                price: this.pPrice.priceValue,
            };
        }
        else {
            return {
                label: translate(t.client.cross_selling_bottomsheet.button.continue),
                price: null,
            };
        }
    }
    addToCart() {
        this.domainCrossSellingCreator.items.raw.map((item) => {
            if (!item.quantity.isZero) {
                this.purchaseOrderPayload.addOrderLine(new OrderLine({
                    productInstanceCreator: item.itemCreator,
                    quantity: item.quantity,
                }));
            }
        });
    }
};
PCrossSellingBeforeCartOpenningBottomSheet = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PCrossSellingCreatorFactory !== "undefined" && PCrossSellingCreatorFactory) === "function" ? _a : Object, typeof (_b = typeof BottomSheetCrossSellingCreator !== "undefined" && BottomSheetCrossSellingCreator) === "function" ? _b : Object, typeof (_c = typeof CrossSellingItemInstancePriceService !== "undefined" && CrossSellingItemInstancePriceService) === "function" ? _c : Object, typeof (_d = typeof LocalizationProvider !== "undefined" && LocalizationProvider) === "function" ? _d : Object, typeof (_e = typeof PurchaseOrderPayload !== "undefined" && PurchaseOrderPayload) === "function" ? _e : Object])
], PCrossSellingBeforeCartOpenningBottomSheet);
export { PCrossSellingBeforeCartOpenningBottomSheet };
